import React from "react";

const MAP = {
  pending:    { label: "PENDIENTE", cls: "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-950 dark:text-amber-300" },
  in_transit: { label: "EN TRÁNSITO", cls: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-950 dark:text-blue-300" },
  delivered:  { label: "ENTREGADO", cls: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950 dark:text-emerald-300" },
  exception:  { label: "INCIDENCIA", cls: "bg-red-100 text-red-800 border-red-300 dark:bg-red-950 dark:text-red-300" },
  paid:       { label: "PAGADA", cls: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950 dark:text-emerald-300" },
  cancelled:  { label: "ANULADA", cls: "bg-neutral-200 text-neutral-700 border-neutral-300 dark:bg-neutral-800 dark:text-neutral-400" },
};

export function StatusBadge({ status, testid }) {
  const s = MAP[status] || { label: (status || "").toUpperCase(), cls: "bg-neutral-100 text-neutral-700 border-neutral-300" };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center border px-2 py-0.5 text-[10px] font-mono font-bold tracking-wider rounded-none ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
